import type { ProducePlanFromOrderAccess, UserRole } from "~/gql/graphqlBase.generated";

import { canCreatePlanFromOrder } from "~/auth/roleChecks";

const productionAllocationAccess = (
	produceEnabled: boolean,
	user?: Maybe<SFUser>,
	myUserRoles?: UserRole[],
	access?: ProducePlanFromOrderAccess
): boolean => produceEnabled && canCreatePlanFromOrder(user, myUserRoles, access);

export default productionAllocationAccess;
